export const inlineeditTokens = {
  inlineedit: {
    root: {
      focusBorderColor: '{surface.400}',
      errorBorderColor: '{danger.color}',
      borderRadius: '0'
    }
  }
};

export type InlineEditTokens = typeof inlineeditTokens;
